import { LoaderFunction } from "react-router-dom";
import { experimentsApi } from "src/api/services/experimentsApi";
import { store } from "src/api/store";

export const experimentVariantsLoader: LoaderFunction = ({ params }) => {
  if (params.experimentId != null) {
    return store
      .dispatch(
        experimentsApi.endpoints.getVariantsForExperiment.initiate(
          params.experimentId,
        ),
      )
      .unwrap();
  }
};
